import { cn } from "@/lib/utils";
import { ComponentProps } from "react";
import { Link as RouterLink } from "react-router";

export function Link({
  children,
  className,
  ...props
}: ComponentProps<typeof RouterLink>) {
  return (
    <RouterLink
      className={cn("text-brand-ink underline text-md", className)}
      {...props}
    >
      {children}
    </RouterLink>
  );
}
